import { Injectable } from '@angular/core'
import { MatStepper } from '@angular/material/stepper'
import { BehaviorSubject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class GbEventTicketGuestStepperViewController {
  selectedStepSubject$ = new BehaviorSubject<number>(0)
  selectedStep$ = this.selectedStepSubject$.asObservable()
  private _matStepper!: MatStepper

  set matStepper(matStepper: MatStepper) {
    this._matStepper = matStepper
  }

  get matStepper(): MatStepper {
    return this._matStepper
  }

  showGuestForm(): void {
    this.selectedStepSubject$.next(0)
  }

  progressStepper(): void {
    this.matStepper.next()
  }
}
